<template>
  <div>
    <v-container grid-list-xl fluid class="px-8 py-4">
      <div class="mb-3">
        <h1 class="fs-18 lh-18 text-uppercase mt-1 font-weight-700">VENDORS</h1>
        <v-breadcrumbs class="px-0 py-2" :items="breadcrumbs"></v-breadcrumbs>
      </div>
      <v-row no-gutters align="center" justify="space-between" class="mb-3">
        <v-col cols="12" sm="6">
          <h1 class="fs-20 font-weight-bold bluedarken--text">
            Vendor List
          </h1>
        </v-col>
        <v-col cols="12" sm="auto" class="px-0">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn color="primary" icon medium v-on="on">
                <v-icon
                  @click="refresh"
                  color="bluedarken"
                  class="icon-bold icon-large"
                  large
                >
                  mdi-refresh
                </v-icon>
              </v-btn>
            </template>
            <span>
              Refresh
            </span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-card class="elevation-card rounded-10">
        <v-card-title class="mb-3">
          <v-row no-gutters align="center">
            <v-col sm="3" class="mr-2">
              <v-text-field
                class="pt-0 mt-0"
                id="search"
                v-model="search"
                append-icon="search"
                placeholder="Search"
                @keyup="searchBrand()"
                single-line
                hide-details
                solo
                dense
              ></v-text-field>
            </v-col>
            <v-spacer />
            <v-col cols="auto" class="pl-1">
              <v-btn
                class="btn-medium"
                depressed
                color="menuActive"
                dark
                @click="addNew"
              >
                Add New Vendor
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          :loading="loading"
          :options.sync="options"
          :must-sort="true"
          :server-items-length="totalItems"
          :sort-desc.sync="descending"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 25]
          }"
        >
          <v-progress-linear
            slot="progress"
            color="primary"
            indeterminate
          ></v-progress-linear>
          <template
            v-slot:item.action="{ item }"
            v-if="hasPermission('create_sshcp_master_data', 'create')"
          >
            <!-- <v-btn
              icon
              :id="'btn-detail' + item.id"
              @click="detail(item.id)"
              v-if="hasPermission('view_master_data', 'view')"
            >
              <v-icon color="green">remove_red_eye</v-icon>
            </v-btn> -->
            <v-btn
              icon
              :id="'btn-edit' + item.id"
              @click="toEdit(item)"
              v-if="hasPermission('create_sshcp_master_data', 'create')"
            >
              <v-icon color="secondblue">mdi-square-edit-outline</v-icon>
            </v-btn>
          </template>
          <template v-slot:no-data>
            <label>No data displayed</label>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
    <v-dialog v-model="showDialog" id="showDialog" persistent max-width="500px">
      <v-card class="rounded-10">
        <ValidationObserver ref="obs">
          <v-form @submit.prevent="save" class="pa-0">
            <v-card-title
              class="primary white--text fs-16 lh-20 font-weight-bold py-4 px-6 rounded-top-left-10 rounded-top-right-10"
            >
              <span class="pa-0">
                {{ isCreate ? 'Add New' : 'Edit' }} Vendor
              </span>
            </v-card-title>
            <v-card-text class="pb-0">
              <v-row align="center">
                <v-col sm12>
                  <ValidationProvider
                    name="Name"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label>Name</label>
                    <v-text-field
                      single-line
                      outlined
                      v-model="name"
                      placeholder="Name"
                      required
                      :error-messages="errors"
                      autocomplete="none"
                      dense
                    ></v-text-field>
                  </ValidationProvider>
                  <ValidationProvider
                    name="Email"
                    rules="required|email"
                    v-slot="{ errors }"
                  >
                    <label>Email</label>
                    <v-text-field
                      single-line
                      outlined
                      v-model="email"
                      placeholder="Email"
                      type="email"
                      required
                      :error-messages="errors"
                      dense
                    ></v-text-field>
                  </ValidationProvider>
                  <ValidationProvider
                    name="Address"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label>Address</label>
                    <v-textarea
                      single-line
                      outlined
                      v-model="address"
                      placeholder="Address"
                      autocomplete="none"
                      required
                      :error-messages="errors"
                      dense
                    ></v-textarea>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="pb-6 px-6">
              <v-spacer></v-spacer>
              <v-btn
                color="#bd1e19"
                dark
                @click="closeDialog()"
                class="btn-medium px-4"
              >
                Close
              </v-btn>
              <v-btn color="primary" class="btn-medium px-4" dark type="submit">
                {{ isCreate ? 'Submit' : 'Save' }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '@/components/progress_dialog';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import ACLMixin from '@/mixins/ACLMixin';
import paginationMixin from '@/mixins/paginationMixin';

export default {
  components: { 'progress-dialog': ProgressDialog },
  mixins: [ACLMixin, paginationMixin],
  data() {
    return {
      progressDialogLoading: false,
      loading: true,
      items: [],
      descending: true,
      sort: '',
      totalItems: 0,
      options: {
        sortBy: ['updated_at'],
        itemsPerPage: 10
      },
      search: '',
      isSearch: false,
      breadcrumbs: [
        {
          text: 'Master Data',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Vendor List',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      page: 1,
      pageCount: 0,
      // itemsPerPage: 10,
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Email', value: 'email' },
        { text: 'Created At', value: 'created_at' },
        { text: 'Created By', value: 'created_by', sortable: false },
        { text: 'Updated At', value: 'updated_at' },
        { text: 'Updated By', value: 'updated_by', sortable: false },
        {
          text: 'Action',
          value: 'action',
          align: 'center',
          sortable: false
        }
      ],
      timeout: null,
      isCreate: false,
      showDialog: false,
      name: '',
      email: '',
      address: '',
      id: null
    };
  },
  watch: {
    descending() {
      this.getData();
    }
  },
  mounted() {
    this.refresh();
  },
  methods: {
    async refresh() {
      await this.getData();
    },
    searchBrand() {
      this.isSearch = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getData();
      }, 900);
    },
    getData() {
      this.loading = true;
      let { page, itemsPerPage, sortBy } = this.options;
      if (this.isSearch) {
        page = 1;
      }
      if (this.descending) {
        this.sort = 'desc';
      } else {
        this.sort = 'asc';
      }
      const sort = this.sort;
      const search = {
        name: this.search || '',
        address: this.search || '',
        email: this.search || ''
      };
      return this.$store
        .dispatch('sshcp/getVendor', {
          page,
          sort,
          limit: itemsPerPage,
          search,
          orderBy: sortBy ? sortBy[0] : 'updated_at'
        })
        .then(data => {
          this.loading = false;
          this.isSearch = false;
          if (data.code === 200) {
            this.items = data.data.result.map(item => {
              return {
                ...item,
                created_by:
                  item.logCreate.length > 0
                    ? item.logCreate[0].user.email
                    : '-',
                updated_by:
                  item.logUpdate.length > 0 ? item.logUpdate[0].user.email : '-'
              };
            });
            this.totalItems = data.data.total_data;
            // this.options = data.data.pagination;
            page = data.data.pagination.current_page;
            itemsPerPage = data.data.pagination.per_page;
            this.options = { page, itemsPerPage };
          } else {
            Swal.fire('Failed!', data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.loading = false;
          Swal.fire('Failed!', err.message.text_en, 'error');
        });
    },
    async save() {
      const validated = await this.$refs.obs.validate();
      if (validated) {
        Swal.fire({
          title: '',
          text: 'Are you sure want to save this data?',
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No'
        }).then(result => {
          if (result.value) {
            this.progressDialogLoading = true;
            let body = {
              name: this.name.trim(),
              address: this.address.trim(),
              email: this.email.trim(),
              uniqueField: {
                name: 'email'
              }
            };
            if (this.isCreate) {
              return this.$store
                .dispatch('sshcp/createVendor', body)
                .then(data => {
                  this.progressDialogLoading = false;
                  if (data.code === 200) {
                    this.closeDialog();
                    this.clear();
                    Swal.fire('Success!', data.message.text_en, 'success');
                    this.getData();
                  } else {
                    this.progressDialogLoading = false;
                    Swal.fire('Failed!', data.message.text_en, 'error');
                  }
                })
                .catch(err => {
                  this.progressDialogLoading = false;
                  Swal.fire('Failed!', err.message.text_en, 'error');
                });
            } else {
              return this.$store
                .dispatch('sshcp/updateVendor', {
                  id: this.id,
                  data: body
                })
                .then(data => {
                  this.progressDialogLoading = false;
                  this.isSearch = false;
                  if (data.code === 200) {
                    this.closeDialog();
                    this.clear();
                    Swal.fire('Success!', data.message.text_en, 'success');
                    this.getData();
                  } else {
                    this.progressDialogLoading = false;
                    Swal.fire('Failed!', data.message.text_en, 'error');
                  }
                })
                .catch(err => {
                  this.loading = false;
                  Swal.fire('Failed!', err.message.text_en, 'error');
                });
            }
          }
        });
      }
    },
    addNew() {
      this.showDialog = true;
      this.isCreate = true;
    },
    closeDialog() {
      this.showDialog = false;
      this.isCreate = false;
      this.clear();
    },
    async clear() {
      this.id = null;
      this.name = '';
      this.email = '';
      this.address = '';
      requestAnimationFrame(() => {
        this.$refs.obs.reset();
      });
    },
    toEdit(item) {
      this.id = item.id;
      this.name = item.name;
      this.email = item.email;
      this.address = item.address;
      this.isCreate = false;
      this.showDialog = true;
    }
  }
};
</script>
